import { render, staticRenderFns } from "./D.vue?vue&type=template&id=06718939&scoped=true&"
import script from "./D.vue?vue&type=script&lang=js&"
export * from "./D.vue?vue&type=script&lang=js&"
import style0 from "./D.vue?vue&type=style&index=0&id=06718939&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06718939",
  null
  
)

export default component.exports